<div id="wizard" class="form_wizard wizard_horizontal">
  <ul class="wizard_steps anchor">
    <ng-content select="li[ap-step]"></ng-content>
  </ul>
</div>
